/*
 * @Description: 路由跳转控制中心
 * @Author: 任录
 * @Date: 2019-07-22 15:13:52
 * @LastEditTime: 2021-09-09 11:38:04
*/
import { getToken } from '@/utils/auth' // get token from cookie

import Vue from 'vue'
import Router from 'vue-router'

import aboutRoutes from './about'
import customerRoutes from './customer'
import homeRoutes from './home'
import productRoutes from './product'
import solutionRoutes from './solution'
import errorRoutes from './error'
import store from '../store'

import adminRouter from './admin'

Vue.use(Router)

export const children = [...homeRoutes, ...solutionRoutes, ...productRoutes, ...aboutRoutes, ...customerRoutes,]
export const adminRouters = adminRouter
const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: '',
      component: resolve => require(['@/views/Main'], resolve),
      children
    },
    ...adminRouters,
    ...errorRoutes
  ]
})

router.beforeEach((to, from, next) => {
  console.log(to, from)
  if (!from.meta.noBefor) {
    store.dispatch('router/getBeforeRoute', from)
  }
  if (!to.meta.noBefor) {
    store.dispatch('router/getNeRoute', to.fullPath)
  }
  store.dispatch(
    'permission/generateRoutes'
  )
  window.scroll(0, 0)
  const hasToken = getToken()
  console.log('hasToken', hasToken)
  if (hasToken) {
    next()
  } else {
    if (to.path === '/adminLogin') {
      next()
    } else if (to.path.includes('/admin') && to.path !== '/adminLogin') {
      next({ path: '/' })
    } else {
      next()
    }
  }
})

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router


// WEBPACK FOOTER //
// ./src/router/index.js